export const UserMessage = ({ message }) => (
  <div className="flex justify-end gap-4 mt-3 items-center max-w-[calc(100%-80px)] ml-auto">
    <div className="bg-[#F4F4F4] border border-[#D4D4D4] rounded-[14px] p-4">
      <p className="text-primary-text font-semibold text-base">{message}</p>
    </div>
  </div>
);
